import axios from 'axios'
import { getSavedState, saveState } from '@state/helpers'
import _ from 'lodash'

export const state = {
  currentUser: getSavedState('auth.currentUser'),
}

export const mutations = {
  SET_CURRENT_USER(state, newValue) {
    state.currentUser = newValue
    saveState('auth.currentUser', newValue)
    setDefaultAuthHeaders(state)
  },
}

export const getters = {
  // Whether the user is currently logged in.
  loggedIn(state) {
    return !!state.currentUser
  },
}

export const actions = {
  // This is automatically run in `src/state/store.js` when the app
  // starts, along with any other actions named `init` in other modules.
  init({ state, dispatch }) {
    setDefaultAuthHeaders(state)
  },

  // Logs in the current user.
  async logIn({ commit, dispatch, getters }, { email, password } = {}) {
    // if (getters.loggedIn) return dispatch('validate')
    let token = await axios.post('/consumer-api/authenticate/token', {
      email,
      password,
    })
    token = token.data
    await setDefaultAuthHeadersFromToken(token)
    let user = await dispatch('customer/fetchUser', { email }, { root: true })
    user = {
      ...user,
      token,
      tokenExpiration: Date.now() + 1800000, // Set 30 minute expiration time
      // tokenExpiration: Date.now() + 120000, // 2 minutes for testing
    }
    commit('SET_CURRENT_USER', user)
    // Return user
    return user
  },

  // Logs out the current user.
  logOut({ commit }) {
    window.localStorage.clear()
    window.sessionStorage.clear()
    commit('referrer/SET_REFERRER_DATA', null, { root: true })
    commit('SET_CURRENT_USER', null)
    commit('customer/UPDATE_CART', null, { root: true })
  },
}

// ===
// Private helpers
// ===

function setDefaultAuthHeaders(state) {
  let auth = ''
  if (state.currentUser && _.get(state, 'currentUser.token'))
    auth = 'Bearer ' + _.get(state, 'currentUser.token')

  axios.defaults.headers.Authorization = auth
}

function setDefaultAuthHeadersFromToken(token) {
  if (token) axios.defaults.headers.Authorization = 'Bearer ' + token
  else axios.defaults.headers.Authorization = ''
}
